module.exports = __webpack_public_path__ + "static/media/gradient04.0ea5f7ce.jpg";